export default __webpack_public_path__ + "static/media/KZ.T.08.2302 black.dc5f0fde.svg";